import React, { createContext, useState } from "react";
import { useTranslation } from "react-i18next";

const AppContext = createContext();
const AppProvider = ({ site: siteInProps, iam: iamInProps, children }) => {
    const [site, setSite] = useState(siteInProps);
    const [iam, setIam] = useState(iamInProps);

    const saveSite = (site) => {
        setSite(site);
    };

    const saveIam = (iam) => {
        setIam(iam);
    };

    const { t } = useTranslation();

    return <AppContext.Provider value={{ site, saveSite, iam, saveIam, t }}>{children}</AppContext.Provider>;
};

export { AppContext, AppProvider };
